import { formsListingQuickFetch } from 'FormsUI/earlyRequest/frameworkQuickFetch';
import { getQueryFromSearch, getViewFromPathname, getWindowPathname, getWindowSearch, isFolderPathname } from 'FormsUI/earlyRequest/utils';
const earlyRequester = () => {
  const pathname = getWindowPathname();
  const view = getViewFromPathname(pathname);
  const search = getWindowSearch();
  const query = getQueryFromSearch(search);
  if (!isFolderPathname(pathname)) {
    void formsListingQuickFetch({
      view,
      query
    });
  }
};
earlyRequester();